import React, {Component} from 'react';
import { Carousel } from '../../../components';
import { getDmService } from '../../../services/Api';
import appConfig from '../../../config/app-config';

export default class Dashboard extends Component{
  constructor(props){
    super(props)
    this.state = {
      banners: null,
    }
  }

  componentWillMount = async () => {
    const banners = await getDmService('/Banner/GetDashboard') || [];
    this.setState({banners})
  }
  
  render() {
    const {banners} = this.state;
    return (
      <div>
        {banners && (
          <Carousel
            data={banners.map(p=>{return {url:appConfig.IMAGE_PATH + p.imagem, backgroundColor: '#fff'}})}
            data2={[
              {
                url: 'https://i.imgur.com/FtSJGHZ.jpg',
                backgroundColor: '#fff'
              },
              {
                url: 'https://i.imgur.com/o349G5L.jpg',
                backgroundColor: '#0d377f'
              },
              {
                url: 'https://i.imgur.com/vRxGsGJ.png',
                backgroundColor: '#fff'
              },
              {
                url: 'https://i.imgur.com/XQTYCAk.png',
                backgroundColor: '#0d377f'
              }
            ]}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/client/dashboard/index.js